import { FC } from "react";
import { useDispatch } from "react-redux";

import { CardSwitchPromptsWrapperProps } from "./types";
import CardSkeleton from "../CardSkeleton/CardSkeleton";
import CardSwitch from "../CardSwitch/CardSwitch";
import DataLoadError from "../DataLoadError";
import { changePromptStatus, deletePrompt } from "../../store/prompts/slice";

const CardSwitchPromptsWrapper: FC<CardSwitchPromptsWrapperProps> = ({
  prompts,
  active = true,
  skeletonCount = 1,
  loading,
  error,
  onRetry,
}) => {
  const dispatch = useDispatch();

  const handleSwitchChange = (id: number, status: boolean) => {
    dispatch(changePromptStatus({ id: String(id), status }));
  };

  const handleDelete = (id: number) => {
    dispatch(deletePrompt({ id: String(id) }));
  };

  const renderSkeletons = () => {
    return Array.from({ length: skeletonCount }).map((_, index) => (
      <CardSkeleton key={index} />
    ));
  };

  if (loading) return renderSkeletons();

  if (!prompts && error) {
    return (
      <DataLoadError
        message={error}
        onRetry={onRetry}
      />
    );
  }

  if (!prompts) return renderSkeletons();

  return (
    <div>{ prompts.map((prompt) => (
      <CardSwitch
        key={prompt.id}
        id={Number(prompt.id)}
        title={prompt.content}
        onSwitchChange={handleSwitchChange}
        onDelete={handleDelete}
        active={active}
        />
    )) }</div>
  );
};

export default CardSwitchPromptsWrapper;